import stateClasses from "../data/stateClasses";

function init() {
	const search = document.querySelector('.js-site-search');
	const button = document.querySelector('.js-site-search-trigger-button');
	const overlay = document.querySelector('.js-site-search-overlay');
	let isOpen = false;

	button.addEventListener('click', function(e) {
		e.preventDefault();
		document.body.classList.toggle(stateClasses.isSiteSearchOpen);

		isOpen = !isOpen;

		if (isOpen) {
			document.querySelector('.js-site-search-input').focus();
		}
	});

	overlay.addEventListener('click', function(e) {
		e.preventDefault();
		document.body.classList.remove(stateClasses.isSiteSearchOpen);
	});

	search.addEventListener('mouseout', function(e) {
		isOpen = false;
	});
};

export default init;